import { CheckCircle2, MessageCircle, Send, X } from 'lucide-react';
import { Button } from '../../../components';

export interface SuccessStateProps {
  title: string;
  description: string;
  telegramUrl?: string;
  whatsappUrl?: string;
  onClose: () => void;
  labels: { telegram: string; whatsapp: string; close: string };
}

export default function SuccessState({ title, description, telegramUrl, whatsappUrl, onClose, labels }: SuccessStateProps) {
  return (
    <div className="lead-form__success">
      <div className="lead-form__success-icon" aria-hidden="true">
        <CheckCircle2 size={56} />
      </div>
      <h3 className="lead-form__success-title">{title}</h3>
      <p className="lead-form__success-desc">{description}</p>
      <div className="lead-form__success-actions">
        {telegramUrl ? (
          <a className="lead-form__success-link lead-form__success-link--telegram" href={telegramUrl} target="_blank" rel="noreferrer noopener">
            <Send size={16} />
            <span>{labels.telegram}</span>
          </a>
        ) : null}
        {whatsappUrl ? (
          <a className="lead-form__success-link lead-form__success-link--whatsapp" href={whatsappUrl} target="_blank" rel="noreferrer noopener">
            <MessageCircle size={16} />
            <span>{labels.whatsapp}</span>
          </a>
        ) : null}
        <Button variant="ghost" size="md" iconLeft={<X size={16} />} onClick={onClose}>{labels.close}</Button>
      </div>
    </div>
  );
}
